export enum HubInstances {
    TRIUMPH = 'triumph',
    TOTALBATTLE = 'totalbattle'
}
